<template>
  <layout-main-inner title="客户管理">
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <template slot="form">
        <el-radio-group
          v-model="config.customerType"
          @change="handleCurrentChange(1)">
          <el-radio-button :label="null">全部</el-radio-button>
          <el-radio-button :label="1">普通客户</el-radio-button>
          <el-radio-button :label="2">经销商</el-radio-button>
        </el-radio-group>
        <el-input
          v-model="config.keyword"
          clearable=""
          placeholder="请输入客户名称"
          style="width: 280px;margin-left: 10px">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        v-loading="loading"
        border
        :data="list">
        <el-table-column
          :resizable="false"
          label="客户名称"
          min-width="140"
          prop="customerName">
          <template slot-scope="{row}">
            <link-route
              v-if="row.customerType === 2"
              :link-to="`/customer-delivery-list?vendorId=${row.vendorId}&customerId=${row.customerId}&customerName=${row.customerName}`">
              {{ row.customerName }}
            </link-route>
            <span v-else> {{ row.customerName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :resizable="false"
          label="联系人"
          width="80"
          prop="contactMan"></el-table-column>
        <el-table-column
          :resizable="false"
          label="联系手机"
          width="100"
          prop="contactPhone"></el-table-column>
        <el-table-column
          :resizable="false"
          label="联系地址"
          min-width="200"
          prop="contactAddress"></el-table-column>
        <el-table-column
          width="210"
          :resizable="false"
          label="所属部门(公司)"
          prop="departmentName"></el-table-column>
        <el-table-column
          label="经销商小程序码"
          :resizable="false"
          width="110">
          <template slot-scope="{ row }">
            <el-image
              v-if="row.customerType === 2"
              style="width: 60px; height: 60px"
              :src="row.acode"
              :preview-src-list="[row.acode]"></el-image>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="是否经销商"
          width="85">
          <template slot-scope="{row}">
            <el-switch
              :value="row.customerType"
              :active-value="2"
              :inactive-value="1"
              @change="(v)=> { updatecustomer(row, v) }">
            </el-switch>
          </template>
        </el-table-column>
        <!-- <el-table-column
          label="操作"
          width="105">
          <template slot-scope="{row}">
            <el-button
              v-if="row.customerType === 2"
              type="info"
              @click.native="setInfo(row)">业绩设置</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <template slot="footer">
        <pagination-new
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
    </layout-card-wrap>
  </layout-main-inner>
</template>

<script>
import { mapState } from 'vuex'
import Common from '../../service/common'
export default {
  name: 'CustomerList',
  components: { },
  data() {
    return {
      loading: false,
      codeUrl: Common.getwxacode,
      config: {
        pageNum: 1,
        pageSize: 10,
        keyword: '',
        customerType: null
      },
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapState({
      // query: state => state.common.query
    })
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('vendor/getcustomers', {
        payload: this.config,
        success: res => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records.map(i => {
            i.acode = i.customerType === 2 ? this.codeUrl + `?vendorId=${i.vendorId}&path=pages/home/index?customerId=${i.customerId}` : null
            return i
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    updatecustomer(row, v) {
      //  this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     this.$message({
      //       type: 'success',
      //       message: '删除成功!'
      //     });
      //   })
      this.loading = true
      this.$store.dispatch('vendor/updatecustomer', {
        payload: {
          customerId: row.customerId,
          customerType: v
        },
        success: () => {
          this.loading = false
          this.fetchList()
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
